<template>
  <div
    :class="{
      'active-file': folder.isActiveState,
      checked: folder.isCheckedState,
      'no-download': !folder.isDownloadAllowed,
    }"
    class="download-box folder-box d-flex align-center"
    @click="onIconClick">
    <div class="folder-icon-wrapper">
      <download-button
        v-if="folder.isDownloadAllowed"
        ref="downloadButton"
        :item="folder"
        :is-encrypted="false"
        @click.stop />
      <div class="d-flex justify-center align-center">
        <em class="folder-icon file-list-icon simple-folder" />
      </div>
    </div>
    <div class="file-meta">
      <div
        :title="folder.name"
        class="file-name">
        {{ folder.name }}
      </div>
      <span class="file-size">{{ folderSize }}</span>
    </div>
    <qx-checkbox
      v-if="folder.isDownloadAllowed"
      class="check-item"
      :checked="folder.isCheckedState"
      @onChange="onCheckboxChange"
      @click.self="handleClick" />
  </div>
</template>

<script>
import downloadButton from '@/elements/download/downloadButton.vue';
import QxCheckbox from '@/elements/form/QxCheckbox.vue';

import { getDirectorySize } from '@/utils/filters.js';

export default {
  name: 'FolderGridItem',
  components: {
    downloadButton,
    QxCheckbox,
  },
  props: {
    folder: {
      type: Object,
      required: true,
    },
  },
  emits: ['click', 'changeCheckedState'],
  computed: {
    folderSize() {
      return getDirectorySize(this.folder?.size);
    },
  },
  methods: {
    onIconClick({ ctrlKey, metaKey, shiftKey }) {
      this.$emit('click', { isCtrl: ctrlKey || metaKey, isShift: shiftKey });
    },
    onCheckboxChange() {
      this.$emit('changeCheckedState', this.folder);
    },
    handleClick(event) {
      if (!event.shiftKey) {
        event.stopPropagation();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.folder-box {
  height: 76px !important;
  padding: 16px 15px 16px 12px;
  .file-meta {
    width: 65%;
  }
  &:not(.no-download).active-file,
  &:not(.no-download):hover {
    .download-button {
      opacity: 1 !important;
    }
    .folder-icon {
      opacity: 0;
    }
  }
  .folder-icon-wrapper {
    height: 32px;
    width: 32px;
    margin-right: 16px;
    .download-button {
      position: absolute;
      opacity: 0;
      transition: opacity 0.4s ease-in;
      z-index: 1000;
    }
    .folder-icon {
      font-size: 28px;
    }
  }
}
</style>
